import get from 'lodash/get';
import error from 'aurora-utils/error';
import * as types from './constants';

const loggedInUser =
  localStorage.getItem('lang') === 'ar' ? localStorage.getItem('UserNameEn') : localStorage.getItem('UserNameAr');

const defaultState = {
  loading: false,
  loggedIn: !!(localStorage.getItem('access_token') && localStorage.getItem('refresh_token')) || false,
  guestLoggedIn: true,
  verified: false,
  user: loggedInUser || null,
  uid: loggedInUser || null,
  showOTPVerification: !!(localStorage.getItem('otp_pending') === 'true') || false,
  error,
  data: '',
  MarketDataToken: '',
};

export default function authReducer(state = defaultState, action = {}) {
  const authMode = get(action.payload, 'authMode');

  switch (action.type) {
    case types.LOGIN_INITIATE:
      return {
        ...state,
        loading: false,
        error,
      };
    case types.LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.LOGIN_SUCCESS:
      if (authMode === 'eid' || authMode === 'unified' || authMode === 'email') {
        return {
          ...state,
          loading: false,
          loggedIn: false,
          verified: false,
          showOTPVerification: true,
          user: get(action.payload, 'credential.user'),
          uid: get(action.payload, 'credential.user'),
          userEmail: get(action.payload, 'credential.userEmail'),
          error,
        };
      }
      // authMode === 'uaePass'
      if (authMode === 'uaePass') {
        return {
          ...state,
          loading: false,
          loggedIn: !!get(action.payload, 'credential.access_token') || false,
          verified: !!get(action.payload, 'credential.access_token') || false,
          user: get(action.payload, 'credential.user'),
          uid: get(action.payload, 'credential.user'),
          showOTPVerification: !!get(action.payload, 'credential.pinId') || false,
          error,
        };
      }
      // guest login
      return {
        ...state,
        loading: false,
        // loggedIn: !!get(action.payload, 'credential.access_token') || false,
        verified: !!get(action.payload, 'credential.access_token') || false,
        guestLoggedIn: !!get(action.payload, 'credential.access_token') || false,
        user: null,
        uid: null,
        showOTPVerification: false,
        error,
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        loggedIn: false,
        error: action.payload.error,
      };
    // case types.PASSWORD_INVALID:
    //   return {
    //     ...state,
    //     loading: false,
    //     loggedIn: false,
    //     error: action.payload.error,
    //     invalidPassword: true,
    //   };
    case types.REQUEST_OTP:
      return {
        ...state,
        loading: true,
      };
    case types.REQUEST_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        verified: false,
        showOTPVerification: true,
        data: action.payload,
        error,
      };
    case types.REQUEST_OTP_FAIL:
      return {
        ...state,
        loading: false,
        verified: false,
        showOTPVerification: true,
        error: get(action.payload, 'error'),
      };

    // OTP verifucation
    case types.VERIFY_OTP:
      return {
        ...state,
        loading: true,
      };
    case types.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        verified: true,
        loggedIn: true,
        guestLoggedIn: false,
        showOTPVerification: false,
        error,
      };
    case types.VERIFY_OTP_FAIL:
      return {
        ...state,
        loading: false,
        verified: false,
        loggedIn: false,
        showOTPVerification: true,
        error: get(action.payload, 'error'),
      };

    case types.LOGOUT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        loggedIn: false,
        guestLoggedIn: true,
      };
    case types.LOGOUT_FAILURE:
      return {
        ...state,
        loading: false,
        loggedIn: false,
        error: {
          statusCode: get(action.payload, 'error.statusCode'),
          message: get(action.payload, 'error.message'),
          error: get(action.payload, 'error'),
        },
      };
    case types.SUBMIT_CONTACT_US_FORM:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SUBMIT_CONTACT_US_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SUBMIT_CONTACT_US_FORM_FAILED:
      return {
        ...state,
        loading: true,
        error: get(action.payload, 'error'),
      };
    case types.MARKET_LOGIN_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case types.MARKET_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        MarketDataToken: get(action.payload, 'token_market'),
      };
    case types.MARKET_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.VERIFY_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.VERIFY_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        email: get(action.payload, 'email', null),
      };
    case types.VERIFY_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.CREATE_PASSWORD_REQUEST:
      return {
        ...state,
        createPasswordLoading: true,
      };
    case types.CREATE_PASSWORD_SUCCESS:
      return {
        ...state,
        createPasswordLoading: false,
        isPasswordCreated: true,
      };
    case types.CREATE_PASSWORD_FAILURE:
      return {
        ...state,
        createPasswordLoading: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        isPasswordforgoted: true,
        userEmail: get(action.payload, 'userEmail', null),
      };

    case types.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        passwordReseted: true,
      };
    case types.FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        isPasswordforgoted: false,
        error: get(action.payload, 'error', 'oops_something_went_wrong'),
      };
    case types.BACK_TO_LOGIN:
      return {
        ...state,
        isPasswordforgoted: false,
      };
    case types.VERIFY_LINK_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.VERIFY_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
